
  <div class="rule-wrap">
    <Loading v-if="loading" />
    <!-- 没通关 -->
    <template v-else>
      <div v-if="prizeInfo.status === 1" class="content no-reward">
        <h1 class="title">您还没有奖励， 快去通关获取吧！</h1>
        <img class="reward-img" src="@/assets/img/sdws/no-reward.png" alt="" />
        <button @click="handleBtnClick(1)" class="btn">去答题</button>
        <p class="tips">通关时长最短前500名可获得免费山东景点门票</p>
      </div>
      <!-- 没选择心愿 -->
      <div v-else-if="prizeInfo.status === 2" class="content no-choose">
        <h1 class="title">您有一张心愿门票未领取</h1>
        <img
          class="reward-img no-choose-img"
          src="@/assets/img/sdws/reward.png"
          alt=""
        />
        <button @click="handleBtnClick(2)" class="btn no-choose-btn">
          领取
        </button>
        <p class="tips">通关时长最短前500名可获得免费山东景点门票</p>
      </div>
      <!-- 等待颁奖 -->
      <div v-else-if="prizeInfo.status === 3" class="content wait">
        <h1 class="title">当前心愿奖励</h1>
        <!-- <p class="reward-name">{{ prizeInfo.prize }}</p> -->
        <!-- <p class="free-tips">免费门票</p> -->
        <img class="reward-img" :src="prizeInfo.img" alt="" />
        <p class="reward-name">{{ prizeInfo.prize }}</p>
        <p class="reward-detail">{{ prizeInfo.prizeTips }}</p>
        <p class="tips">2021年12月26日 0:00颁奖</p>
        <button class="btn">等待颁奖</button>
        <p class="exa-tips-title">
          <img src="@/assets/img/sdws/exa-tips.png" alt="" />
          温馨提示
        </p>
        <p class="exa-tips">
          闯关用时前500名可获得的心愿奖励，当再次闯关成功后可更改心愿奖励哦！
        </p>
      </div>
      <!-- 得奖 -->
      <div v-else-if="prizeInfo.status === 4" class="content awarded">
        <h1 class="title">当前排名{{ user?.rowNum || '--' }}名</h1>
        <img
          class="reward-tips"
          src="@/assets/img/sdws/reward-tips.png"
          alt=""
        />
        <img class="reward-img" :src="prizeInfo.img" alt="" />
        <p class="reward-name">{{ prizeInfo.prize }}</p>
        <p class="reward-detail">{{ prizeInfo.prizeTips }}</p>
        <p class="tips">恭喜获得奖励</p>
        <button @click="handleBtnClick('receiveAward')" class="btn">
          领取
        </button>
      </div>
      <!-- 已领奖 -->
      <div v-else-if="prizeInfo.status === 5" class="content has">
        <h1 class="title">当前排名{{ user?.rowNum || '--' }}名</h1>
        <img
          class="reward-tips"
          src="@/assets/img/sdws/reward-tips.png"
          alt=""
        />
        <img class="reward-img" :src="prizeInfo.img" alt="" />
        <p class="tips">
          恭喜您获得{{
            `${prizeInfo.prize}${prizeInfo.prizeTips}`
          }}！工作人员将尽快与您取得联系。
        </p>
        <p class="tips" style="margin-top: 5px">
          如有问题请联系节目组官方邮箱：qiluwenhuadahui@163.com。
        </p>
        <button class="btn">恭喜您</button>
      </div>
      <!-- 未中奖 -->
      <div v-else-if="prizeInfo.status === 6" class="content has">
        <h1 class="title">当前排名{{ user?.rowNum || '--' }}名</h1>
        <img
          class="reward-tips"
          src="@/assets/img/sdws/reward-tips.png"
          alt=""
        />
        <img class="reward-img" :src="prizeInfo.img" alt="" />
        <p class="tips">
          恭喜您获得
          ！30个工作日内会有工作人员和您取得联系，奖品将会邮寄到您的手中，请等！
        </p>
        <!-- <button @click="handleBtnClick('receiveAward')" class="btn">
          确定
        </button> -->
      </div>
    </template>
  </div>
  <!-- 领奖 -->
  <Overlay style="z-index: 100" :show="showReceive">
    <ReceiveAward
      @close="showReceive = false"
      @received="handleReceived"
      :user="user"
    />
  </Overlay>
  <!-- <ReceiveAward v-if="showReceive"  @close="showReceive = false" /> -->
  <!-- 选奖品 -->
  <Overlay style="z-index: 100" :show="showReward" :lock-scroll="false">
    <ChooseReward @close="handleChooseReward" />
  </Overlay>
  <div class="mask"></div>
  <img
    @click="$router.go(-1)"
    class="back-btn"
    src="@/assets/img/sdws/back.png"
    alt=""
  />
